import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactModal from "react-modal";
import { withRouter } from "react-router-dom";
import ChangePassword from "../../components/ChangePassword";
import { Button } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import Header from "../../components/Header";
import * as AppActions from "../../actions";

class SettingsContainer extends Component {
  constructor() {
    super();

    this.state = {
      changePassword: false
    };
    this.tablet = window.innerWidth - 40 < 550 ? false : true;
  }

  handleSetPassword(password) {
    this.props.actions.changePassword(password);
  }

  renderControl() {
    const { isConnected } = this.props;

    return (
      <ChangePassword
        tablet={this.tablet}
        isLoading={this.props.isLoading}
        passwordChanged={this.props.passwordChanged}
        isConnected={isConnected}
        onChangePassword={this.handleSetPassword.bind(this)}
      />
    );
  }

  handleChangePassword() {
    this.setState({ changePassword: true });
  }

  handleChangePasswordClose() {
    this.props.actions.resetPasswordChanged();
    this.setState({ changePassword: false });
  }

  renderChangePassword() {
    return (
      <ReactModal
        isOpen={this.state.changePassword}
        style={customStylesRename}
        contentLabel="Example Modal"
        onRequestClose={() => {
          //alert('Modal has been closed.');
        }}
      >
        <div
          style={{
            paddingTop: 40,
            backgroundColor: "white",
            paddingLeft: 0,
            paddingRight: 0,
            borderRadius: 6,
            width: "100%",
            height: "100%"
          }}
        >
          <Icon
            type="MaterialIcons"
            onClick={this.handleChangePasswordClose.bind(this)}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              color: "#e6e6e6",
              cursor: "pointer"
            }}
            size="large"
            name="close"
          />
          {this.renderControl()}
        </div>
      </ReactModal>
    );
  }

  render() {
    const { actions } = this.props;

    return (
      <div>
        {this.renderChangePassword()}
        <Header
          formTitle={"Settings"}
          setSidebarVisibility={actions.setSidebarVisibility}
        ></Header>
        <div className="formsBackground">
          <div className="formSectionContainerX">
            <div
              className="ui formList"
              style={{ padding: this.tablet ? "60px" : "30px" }}
            >
              <div
                className="formControlItem"
                style={{ paddingBottom: "20px", fontSize: "16px" }}
              >
                <div style={{ float: "left", fontWeight: "bold" }}>
                  App Version
                </div>
                <div style={{ float: "right", fontSize: "16px" }}>
                  {this.props.application_version}
                </div>
              </div>
              <div
                className="formControlItem"
                style={{ paddingBottom: "20px", fontSize: "16px" }}
              >
                <div style={{ float: "left", fontWeight: "bold" }}>
                  Environment
                </div>
                <div style={{ float: "right", fontSize: "16px" }}>
                  {this.props.environment}
                </div>
              </div>
              <div
                className="formControlItem"
                style={{ paddingBottom: "20px", fontSize: "16px" }}
              >
                <div style={{ float: "left", fontWeight: "bold" }}>
                  Username
                </div>
                <div style={{ float: "right", fontSize: "16px" }}>
                  {this.props.username}
                </div>
              </div>
              <div
                className="formControlItem"
                style={{ paddingBottom: "10px", fontSize: "16px" }}
              >
                <div
                  style={{
                    float: "left",
                    lineHeight: "36px",
                    fontWeight: "bold"
                  }}
                >
                  Password
                </div>
                <div style={{ float: "right" }}>
                  <Button
                    onClick={this.handleChangePassword.bind(this)}
                    className="ui button"
                    ref="UnToggle"
                    role="button"
                    active
                  >
                    Change password
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const customStylesRename = {
  content: {
    top: "50%",
    width: "85%",
    maxWidth: "400px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    border: "0px",
    height: "320px",
    backgroundColor: "#fff",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

SettingsContainer.propTypes = {};

const mapStateToProps = state => ({
  isConnected: state.informedWebApp.isConnected,
  storeColour: state.informedWebApp.storeColour,
  passwordChanged: state.informedWebApp.passwordChanged,
  isLoading: state.informedWebApp.isLoading,
  username: state.informedWebApp.username,
  environment:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? "Live"
      : "Test",
  application_version: state.informedWebApp.application_version
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SettingsContainer)
);



// WEBPACK FOOTER //
// ./src/containers/SettingsContainer/index.js